import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import React from 'react';

import { buttons } from '@/styles/buttons';

import { DotsIcon } from '@/ui/Icons/DotsIcon';

import { classNames } from '@/utils/classnames';

import { PulsingDot } from '../PulsingDot';

interface AdditionalOptionsTriggerProps {
  isOpen: boolean;
  isMobile: boolean;
  showPulsingDot?: boolean;
}

export const AdditionalOptionsTrigger: React.FC<AdditionalOptionsTriggerProps> = (props) => {
  const { isOpen, isMobile, showPulsingDot } = props;

  return (
    <div className="relative">
      <DropdownMenu.Trigger
        className={buttons({
          size: 'medium',
          color: 'white',
          shape: 'circle',
          iconOnly: true,
          class: 'p-3',
        })}
      >
        {!isMobile && <DotsIcon />}
        {isMobile && (
          <span className="relative size-4">
            <span
              className={classNames(
                'absolute left-0 top-[7.25px] h-[1.5px] w-4 rounded-full bg-current transition-[translate,rotate] duration-200 ease-(--motion-ease-out)',
                isOpen ? 'rotate-45' : '-translate-y-[3px]',
              )}
            />
            <span
              className={classNames(
                'absolute left-0 top-[7.25px] h-[1.5px] w-4 rounded-full bg-current transition-[translate,rotate] duration-200 ease-(--motion-ease-out)',
                isOpen ? '-rotate-45' : 'translate-y-[3px]',
              )}
            />
          </span>
        )}
        <VisuallyHidden>Additional Options</VisuallyHidden>
      </DropdownMenu.Trigger>
      {showPulsingDot && <PulsingDot />}
    </div>
  );
};
